import { useState } from 'react';
import { toast } from 'react-toastify';
import { JobsiteVisitsService } from '../services/jobsite-visits.service';
import { JobsiteService } from '../services/jobsite.service';
import { JobsiteVisitFilesDTO } from '../types/jobsite-visits.types';

interface UploadFilesParams {
  files: File[];
  jobsiteVisitId: string;
  userId: string;
  onProgress?: (message: string) => void;
}

export const useJobsiteVisitFileUpload = () => {
  const [uploading, setUploading] = useState(false);

  const uploadFiles = async ({
    files,
    jobsiteVisitId,
    userId,
    onProgress,
  }: UploadFilesParams): Promise<boolean> => {
    if (files.length === 0) return true;

    try {
      setUploading(true);
      onProgress?.('Uploading files...');

      const filesData: JobsiteVisitFilesDTO = {
        jobsiteVisitId,
        userId,
        files,
      };

      // Only upload to jobsite visit files - not main jobsite files
      await JobsiteVisitsService.createJobsiteVisitFiles(filesData);

      onProgress?.('Files uploaded successfully!');
      return true;
    } catch (error) {
      // Service layer already logs the error, just show user feedback
      toast.warning('Jobsite visit saved but some files failed to upload');
      return false;
    } finally {
      setUploading(false);
    }
  };

  return { uploadFiles, uploading };
};
